/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useMutation } from 'react-query'

import { requestSubscriptionLevelUpdateV1 } from '@modules/billing-api/v1/callers'
import type { operations } from '@modules/billing-api/v1/types'
import type { QueryFunctionReturnType } from '@modules/query/types'

interface UseUpdateSubscriptionErrorResponse {
  error: string
  message: string
  statusCode: number
  success: boolean
  detail: {
    language?: string
    level: 'standard' | 'gold' | 'platinum' | 'enterprise'
    reason: string
    timezone?: {
      name: string
      offset: number
    }
    messages: string[]
  }
}

interface UseUpdateSubscriptionParams {
  organizationId: string
  skipValidations: boolean
  body: operations['requestSubscriptionLevelUpdateV1']['requestBody']['content']['application/json']
}

const useUpdateSubscription = () =>
  useMutation<
    QueryFunctionReturnType<typeof requestSubscriptionLevelUpdateV1>,
    UseUpdateSubscriptionErrorResponse,
    UseUpdateSubscriptionParams
  >({
    mutationFn: ({ organizationId, skipValidations, body }) =>
      requestSubscriptionLevelUpdateV1({
        pathParameters: { organization_id: organizationId },
        queryParameters: { skip_validations: skipValidations },
        body,
      }),
  })

export default useUpdateSubscription
